/** biome-ignore-all lint/correctness/useExhaustiveDependencies: TODO: fix */

import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { Col, Form, Row } from 'antd';
import { clone, pickBy } from 'es-toolkit';
import { t } from 'i18next';
import moment from 'moment';

import { ENV_VARS } from '@/env';
import { isEmpty } from '@/utils/object';

import { DEFAULT_DATE_FORMAT } from '../../../contants/common';
import { QUOTE_SEARCH_FILTER_DATES_FIELDS } from '../../../contants/Fields';
import { getSearchQuoteDefaultFilters } from '../../../contants/ShipmentEnums';
import { getSpotQuoteTransportationInProgress, setWarningModal } from '../../../redux/common/CommonActions';
import {
  getSearchQuoteListInProgress,
  setSearchQuoteFilters,
  setSearchQuoteList,
} from '../../../redux/shipment/ShipmentActions';
import { valueToString } from '../../../utilz';
import Button from '../../components/Buttons/Button';
import SearchQuoteFilterContent from './components/SearchQuoteFilterContent';

const SearchQuoteFilters = () => {
  const { state } = useLocation();
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { quoteKey } = useParams();
  const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';

  const { selectedCompany } = useSelector((state) => state.auth);

  const {
    status,
    transportationGroup,
    quoteNumber,
    transportationProvider,
    hazardousClass,
    spotQuoteCreatedFrom,
    spotQuoteCreateTo,
    prevState,
    bidAge,
  } = state || {};

  const searchQuoteFilters = useSelector((state) => state.shipment.searchQuoteFilters, shallowEqual);

  const updateFiltersAndFetchQuotes = (data) => {
    dispatch(setSearchQuoteList({ data: [], isFirstTime: false, progressing: true }));
    dispatch(setSearchQuoteFilters(data));
    dispatch(getSearchQuoteListInProgress());
  };

  useEffect(() => {
    if (!prevState) {
      dispatch(setSearchQuoteFilters(getSearchQuoteDefaultFilters()));
      dispatch(
        setSearchQuoteList({
          data: [],
          isFirstTime: true,
        }),
      );
    }
  }, []);

  useEffect(() => {
    if (selectedCompany?.companyId) {
      dispatch(getSpotQuoteTransportationInProgress());
    }
  }, [dispatch, selectedCompany?.companyId]);

  useEffect(() => {
    const defaultFilters = getSearchQuoteDefaultFilters();
    const commonFilters = {
      ...defaultFilters,
      ...searchQuoteFilters,
      bidAge: bidAge ?? null,
      hazardousClass: hazardousClass || '',
      quoteNumber: quoteKey || quoteNumber || '',
      quotestatus: status,
      spotQuoteCreatedFrom: spotQuoteCreatedFrom || '',
      spotQuoteCreateTo: spotQuoteCreateTo || '',
      transportationGroup,
    };

    const data = quoteKey
      ? {
          ...defaultFilters,
          ...searchQuoteFilters,
          quoteNumber: quoteKey || quoteNumber || '',
          spotQuoteCreatedFrom: spotQuoteCreatedFrom || '',
          spotQuoteCreateTo: spotQuoteCreateTo || '',
        }
      : commonFilters;

    if (status || (bidAge !== null && bidAge !== undefined)) {
      updateFiltersAndFetchQuotes(data);
    }
  }, [
    status,
    transportationGroup,
    transportationProvider,
    quoteKey,
    spotQuoteCreateTo,
    hazardousClass,
    spotQuoteCreatedFrom,
    bidAge,
  ]);

  useEffect(() => {
    if (searchQuoteFilters) {
      const data = clone(searchQuoteFilters);
      for (const key in data) {
        if (QUOTE_SEARCH_FILTER_DATES_FIELDS.includes(key)) {
          if (data[key]) {
            data[key] = moment(data[key]);
          } else {
            data[key] = '';
          }
        }
      }
      data.quotestatus = data.quotestatus ? data.quotestatus.split(',') : [];

      data.createdBy = data?.createdBy ? data?.createdBy?.split(',') : [];
      data.createdBy = data.createdBy.map((val) => Number(val));
      form.setFieldsValue(data);
    }
  }, [searchQuoteFilters]);

  const handleFilterSubmit = (formData) => {
    // to prevent the form state mutations
    let data = clone(formData);
    if (data.createdByType) {
      delete data.createdByType;
    }
    const isFilterIsEmpty = isEmpty(
      pickBy(data, (value) =>
        value ? (typeof value === 'object' ? Boolean(value?.length) : Boolean(String(value).length)) : false,
      ),
    );
    if (
      isFilterIsEmpty &&
      !data.spotQuoteCreatedFrom &&
      !data.spotQuoteCreateTo &&
      !data.expectedShipFromDate &&
      !data.expectedShipTodate
    ) {
      dispatch(
        setWarningModal({
          description: 'Please enter at least one search criteria',
          open: true,
        }),
      );
    } else {
      data = clone({ ...getSearchQuoteDefaultFilters(), ...data });
      for (const key in data) {
        if (QUOTE_SEARCH_FILTER_DATES_FIELDS.includes(key) && data[key]) {
          data[key] = data[key].format(DEFAULT_DATE_FORMAT);
        }
      }

      data.quotestatus = Array.isArray(data.quotestatus) ? data.quotestatus.join(',') : [];
      data.createdBy = typeof data.createdBy === 'object' ? valueToString(data.createdBy.join(',')) : '';
      dispatch(
        setSearchQuoteList({
          data: [],
          isFirstTime: false,
          progressing: true,
        }),
      );
      dispatch(
        setSearchQuoteFilters({
          ...data,
        }),
      );
      dispatch(getSearchQuoteListInProgress());
    }
  };

  const handleClear = () => {
    form.resetFields();
    form.setFieldsValue({
      CreatedDateFrom: moment(new Date()).subtract(1, 'months'),
      CreatedDateTo: moment(new Date()),
      quotestatus: [],
    });
  };

  return (
    <div className="d-flex flex-direction-column overflow-hidden h-100 br-4">
      <div className="custom-scroll-bar overflow-x-hidden mb-15 flex-1">
        <Form onFinish={handleFilterSubmit} form={form} initialValues={{ createdByType: 1 }}>
          <SearchQuoteFilterContent form={form} />
        </Form>
      </div>
      <Row className="px-15" gutter={15}>
        <Col sm={24} md={12}>
          <Button
            fullWidth
            type="default"
            onClick={handleClear}
            buttonType="button"
            className={isHBUser ? 'hb-button' : ''}
          >
            {t('translation:default.buttons.clear')}
          </Button>
        </Col>
        <Col sm={24} md={12}>
          <Button
            fullWidth
            type="primary"
            onClick={() => form.submit()}
            buttonType="submit"
            className={isHBUser ? 'hb-button' : ''}
          >
            {t('translation:default.buttons.search')}
          </Button>
        </Col>
      </Row>
    </div>
  );
};
export default SearchQuoteFilters;
